
const additionalReadersEl = document.getElementById("additionalReaders")

if (additionalReadersEl) {
	const originalText = additionalReadersEl.innerText;
	const closeText = additionalReadersEl.dataset.text;

	additionalReadersEl.addEventListener("click", function() {
		if (this.innerText === originalText) {
			this.innerText = closeText;
		} else {
			this.innerText = originalText;
		}
	});
}
